export const HOURS_OPTIONS = Array.from({ length: 24 }, (_, hour) => hour);

export const MINUTES_OPTIONS = [0, 15, 30, 45];
